import {
  CloseIcon as AriesCloseIcon,
  Greyscale,
  SearchIcon as AriesSearchIcon,
} from 'glints-aries';
import styled from 'styled-components';

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  min-height: 43px;
  padding: 0 20px;
  background-color: ${Greyscale.white};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

export const SearchIcon = styled(AriesSearchIcon)`
  width: 21px;
  height: 21px;
  margin-right: 4px;
  fill: ${Greyscale.black};
`;

export const CloseIcon = styled(AriesCloseIcon)`
  width: 9px;
  height: 9px;
  margin-left: 6.5px;
  fill: ${Greyscale.white};
  opacity: 0.5;

  &:hover {
    cursor: pointer;
  }
`;

export const InputWrapper = styled.div`
  flex: 1;
  min-width: 120px;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 16px;

  &::placeholder {
    color: rgba(191, 191, 191, 0.87);
  }

  &:focus::placeholder {
    color: rgba(115, 115, 115, 0.87);
  }
`;

export const Tag = styled.span`
  background-color: ${({ bgColor }) => bgColor || '#009688'};
  padding: 6px 12px;
  margin: 4px 8px 4px 0;
  border-radius: 4px;
`;
